module.exports = __webpack_public_path__ + "static/media/6. Niken.b99da1ec.png";